import React from 'react';
import styled from 'styled-components';

const A3Style = styled.svg``;

export const A3 = ({ color }) => {
	return (
		<A3Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.264'
			height='18.277'
			viewBox='0 0 22.264 18.277'
		>
			<path
				id='Family'
				d='M747.54,410.714a4.915,4.915,0,0,0-6.86-6.924,5.775,5.775,0,0,0-.559.5,5.5,5.5,0,0,0-1.045-1.483,5.332,5.332,0,0,0-7.937,7.1c-1.579,1.534-3.087,3-3.087,5.569v1.762a.86.86,0,0,0,.863.853h1.945v.581a.854.854,0,0,0,.85.85v0h15.2a.849.849,0,0,0,.85-.853v-.444h1.689a.864.864,0,0,0,.864-.857v-1.6c0-2.372-1.289-3.621-2.777-5.061Zm-5.821-5.563h0a3.2,3.2,0,1,1,2.266,5.733,4.6,4.6,0,0,0,.122-1.014,4.141,4.141,0,0,0-3.087-3.984,3.154,3.154,0,0,1,.7-.735ZM740,407.472h0a2.408,2.408,0,0,1,2.394,2.4,2.4,2.4,0,0,1-4.8,0,2.416,2.416,0,0,1,2.406-2.4Zm-7.248-3.448h0a3.618,3.618,0,0,1,6.113,1.893,4.141,4.141,0,0,0-2.978,3.953c0,.1.006.188.006.279a3.526,3.526,0,0,1-.589.046,3.611,3.611,0,0,1-2.552-6.171Zm-.183,13.793h0v-.525l.006-.013v-2.452a.516.516,0,0,0-1.033,0v1.556h-1.774v-.905c0-1.857,1.264-3.081,2.589-4.362l.061-.061a5.338,5.338,0,0,0,3.834.764l.116-.019a3.753,3.753,0,0,0,.292.471c-1.131,1.1-2.169,2.193-2.169,4.077v1.285a.873.873,0,0,0,.019.185Zm11.223-1.042h-1.008v-.9a.513.513,0,0,0-1.027,0v1.945h-3.517v-1.945a.514.514,0,0,0-1.028,0v.9H736.2v-.428c0-1.215.826-2.057,1.72-2.926a4.046,4.046,0,0,0,.523.256l.012,0,.012.007a4.13,4.13,0,0,0,1.531.3,4.082,4.082,0,0,0,2.067-.563c.929.9,1.724,1.681,1.724,2.926v.428Zm4.813-.258h-1.513v-1.334a.513.513,0,0,0-1.027,0v2.635h-.583a.962.962,0,0,0,.024-.185v-1.285a4.933,4.933,0,0,0-1.822-3.737,4.9,4.9,0,0,0,2.588-.747l.073.07v0c1.215,1.173,2.26,2.181,2.26,3.843v.741Z'
				transform='translate(-728.053 -401.25)'
				fill={color}
			/>
		</A3Style>
	);
};
